import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Desktop24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M19 3C20.6569 3 22 4.34315 22 6V12.15C22 12.7023 21.5523 13.15 21 13.15L3 13.15C2.44772 13.15 2 12.7023 2 12.15V6C2 4.34315 3.34315 3 5 3H19ZM3.45958 14.85C2.79168 14.85 2.32337 15.511 2.77041 16.0073C3.31952 16.6168 4.11501 17 5 17H8.925C9.5187 17 9.99999 17.4813 9.99999 18.075C9.99999 18.6687 9.5187 19.15 8.92499 19.15H5.99999C5.53055 19.15 5.14999 19.5306 5.14999 20C5.14999 20.4694 5.53055 20.85 5.99999 20.85L18 20.85C18.4694 20.85 18.85 20.4694 18.85 20C18.85 19.5306 18.4694 19.15 18 19.15H15.075C14.4813 19.15 14 18.6687 14 18.075C14 17.4813 14.4813 17 15.075 17H19C19.885 17 20.6805 16.6168 21.2296 16.0073C21.6766 15.511 21.2083 14.85 20.5404 14.85L3.45958 14.85Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
